module.exports = __webpack_public_path__ + "static/media/MCB-and-Fuse.3d693b2c.jpg";